import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import useClickOutside from "hooks/useClickOutside";
import SketchPicker from "components/common/color-picker/SketchPicker";
import { Button } from "components/bootstrap";
const colorPreviewSize = 21;
const Wrapper = styled.div`
  position: relative;
`;
const ColorPreview = styled.span(
  ({ $color, theme }) => css`
    background-color: ${$color};
    width: ${colorPreviewSize}px;
    height: ${colorPreviewSize}px;
    display: block;
    border: 1px solid ${theme.colors.variant.darker.default};
    border-radius: 2px;
  `
);
const StyledButton = styled(Button)`
  padding: 0;
`;
const StyledSketchPicker = styled(SketchPicker)`
  position: absolute;
  transform: translateY(calc(-50% - ${colorPreviewSize / 2}px));
  left: calc(50% + ${colorPreviewSize - 3}px);
  z-index: 2;

  &::after,
  &::before {
    right: 100%;
    top: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-color: transparent;
    border-right-color: #fff; /* matching color from SketchPicker background-color */
    border-width: 9px;
    margin-top: -9px;
  }

  &::before {
    border-color: transparent;
    border-right-color: rgba(0, 0, 0, 0.15); /* matching color from SketchPicker box-shadow */
    border-width: 10px;
    margin-top: -10px;
  }
`;
const ThemeEditorColor = ({ color, onChange, label }) => {
  const [show, setShow] = useState(false);
  const ref = useClickOutside(() => setShow(false));
  const _handleToggle = () => {
    setShow(!show);
  };
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "link", onClick: _handleToggle, title: label }, /* @__PURE__ */ React.createElement(ColorPreview, { $color: color })), show && /* @__PURE__ */ React.createElement("div", { ref, role: "dialog" }, /* @__PURE__ */ React.createElement(
    StyledSketchPicker,
    {
      disableAlpha: true,
      color,
      onChangeComplete: ({ hex }) => onChange(hex)
    }
  )));
};
export default ThemeEditorColor;
